import { NodeType, PermissionType, EpiPageRouteKey, UserType } from '@enums';

export const sxnavigation = {
  menuItems: [
    {
      id: '1',
      parentId: '-1',
      displayText: 'core.sidebar.dashboard',
      linkUrl: '/secure/dashboard',
      iconName: '#sx-start-dashboard',
      nodeType: NodeType.System,
      disabled: false
    },
    {
      id: '2',
      parentId: '-1',
      displayText: 'core.sidebar.metering',
      iconName: '#sx-anlaggningar',
      linkUrl: '/secure/meteringpoints',
      nodeType: NodeType.System,
      checkData: true
    },
    {
      id: '3',
      parentId: '-1',
      displayText: 'core.sidebar.contracts',
      iconName: '#sx-avtal',
      linkUrl: '/secure/contracts',
      nodeType: NodeType.System,
      permissions: [PermissionType.ViewAgreements],
      checkData: true,
      items: [
        {
          id: '925',
          parentId: '3',
          displayText: 'Tillval',
          linkUrl: '/secure/contracts/about',
          nodeType: NodeType.System,
          key: EpiPageRouteKey.ContractAddonsFaq
        },
        {
          id: '921',
          parentId: '3',
          displayText: 'FAQ',
          linkUrl: '/secure/contracts/faq',
          nodeType: NodeType.System,
          key: EpiPageRouteKey.ContractFaq
        },
        {
          id: '10',
          parentId: '3',
          displayText: 'Sidan finns inte',
          linkUrl: '/secure/contracts2/dummy',
          nodeType: NodeType.System
        }
      ]
    },
    {
      id: '4',
      parentId: '-1',
      displayText: 'core.sidebar.invoices',
      iconName: '#sx-faktura',
      linkUrl: '/secure/invoices',
      nodeType: NodeType.System,
      checkData: true
    },
    {
      id: '5',
      parentId: '-1',
      displayText: 'core.sidebar.services',
      iconName: '#sx-energitjanster',
      linkUrl: '/secure/products',
      nodeType: NodeType.System
    },
    {
      id: '6',
      parentId: '-1',
      displayText: 'core.sidebar.analyze',
      iconName: '#sx-karriarsutveckling',
      linkUrl: '/secure/analyze',
      nodeType: NodeType.System,
      checkData: true
    },
    {
      id: '7',
      parentId: '-1',
      displayText: 'core.sidebar.environment',
      iconName: '#sx-miljo',
      linkUrl: '/secure/environment',
      nodeType: NodeType.System,
      items: [
        {
          id: '601',
          parentId: '7',
          displayText: 'Miljö (Alla) 1',
          linkUrl: '/secure/environment/:id',
          nodeType: NodeType.Epi,
          items: [
            {
              id: '1034',
              parentId: '7',
              displayText: 'Informationssida Epi',
              linkUrl: '/secure/environment/:id',
              nodeType: NodeType.Epi
            },
            {
              id: '12',
              parentId: '7',
              displayText: 'Miljö (FTG) 1.2',
              link: '/secure/environment',
              userTypes: [UserType.Company],
              nodeType: NodeType.Epi,
              navigationExtras: {
                queryParams: { id: '925' }
              }
            },
            {
              id: '921',
              parentId: '7',
              displayText: 'Miljö (Alla) 1.3',
              linkUrl: '/secure/environment/:id',
              nodeType: NodeType.Epi
            },
            {
              id: '',
              parentId: '7',
              displayText: 'Miljö (Brf) 1.4',
              llinkUrlink: '/secure/environment/environment-1-4',
              nodeType: NodeType.System,
              userTypes: [UserType.Brf]
            }
          ]
        },
        {
          id: '11',
          parentId: '7',
          displayText: 'Miljö 2 (system)',
          linkUrl: '/secure/environment/level-2',
          nodeType: NodeType.System,
          items: [
            {
              parentId: '11',
              displayText: 'Miljö 2.1 (system)',
              linkUrl: '/secure/environment/level-2/1',
              nodeType: NodeType.System
            },
            {
              parentId: '11',
              displayText: 'Miljö 2.2',
              disabled: true,
              nodeType: NodeType.System
            },
            {
              id: '999',
              parentId: '11',
              displayText: 'Miljö 2.3 (epi)',
              linkUrl: '/secure/environment/:id',
              nodeType: NodeType.Epi
            }
          ]
        }
      ]
    },
    {
      id: '8',
      parentId: '-1',
      displayText: 'core.sidebar.customers',
      iconName: '#sx-behorighetsadministration',
      linkUrl: '/secure/customers',
      nodeType: NodeType.System,
      userTypes: [UserType.Private, UserType.Brf, UserType.Company]
    },
    {
      id: '9',
      parentId: '-1',
      displayText: 'NPM',
      iconName: '#sx-exergi',
      linkUrl: 'https://www.npmjs.com',
      externalRedirect: true,
      hrefTargetType: '_blank'
    }
  ]
};
